import { render, staticRenderFns } from "./CashPayment.vue?vue&type=template&id=1060b0c2"
import script from "./CashPayment.vue?vue&type=script&lang=js"
export * from "./CashPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports